import LoadInView from "../../../components/LoadInView";
import {
  CommonContainer,
  MediaQuery,
  mobileQuery,
} from "../../../components/Grid";
import { Parallax } from "react-scroll-parallax";
import React from "react";

const AssetSection = ({ sectionData }) => {
  const isMobile = MediaQuery(mobileQuery);

  const {
    id,
    title,
    subtitle,
    description,
    bannerImage,
    bannerImageMobile,
    features,
    functions,
    cases,
  } = sectionData;

  return (
    <LoadInView id={id}>
      <div className="section" id={`section-${id}`}>
        {!isMobile ? (
          <div className="figure">
            <Parallax y={[30, -30]} x={[-30, 0]} tagOuter="figure"></Parallax>
          </div>
        ) : (
          ""
        )}

        <div className="figure">
          <Parallax y={[20, -20]} x={[-20, 20]} tagOuter="figure"></Parallax>
        </div>

        <CommonContainer>
          {/* 섹션 타이틀 */}
          <h3 className="section-title">
            <LoadInView>
              <small>{subtitle}</small>
              {title}
            </LoadInView>
          </h3>

          <div className="content-block">
            {/* 섹션 설명 */}
            <LoadInView>
              <p className="section-desc">{description}</p>
            </LoadInView>

            {/* 배너 이미지 */}
            <LoadInView>
              <div className="section-banner">
                <img src={bannerImage} alt="" className="mo-none" />
                <img src={bannerImageMobile} alt="" className="mo-block" />
              </div>
            </LoadInView>

            {/* 특장점 */}
            {features && (
              <LoadInView>
                <article className="article features">
                  <h4 className="article-title">특장점</h4>
                  <div className="article-content">
                    <div className="list">
                      {features.map((feature, index) => (
                        <div key={index} className="item">
                          <img src={feature.icon} alt="" className="icon" />
                          <p className="item-title">{feature.title}</p>
                          <p className="item-desc">{feature.description}</p>
                        </div>
                      ))}
                    </div>
                  </div>
                </article>
              </LoadInView>
            )}

            {/* 주요 기능 */}
            {functions && (
              <LoadInView>
                <article className="article functions">
                  <h4 className="article-title">주요 기능</h4>
                  <div className="article-content">
                    <div className="list">
                      {functions.map((func, index) => (
                        <div key={index} className="item">
                          <img src={func.icon} alt="" className="icon" />
                          <p className="item-title">{func.title}</p>
                          <p className="item-desc">{func.description}</p>
                        </div>
                      ))}
                    </div>
                  </div>
                </article>
              </LoadInView>
            )}

            {/* 적용 사례 */}
            {cases && (
              <LoadInView>
                <article className="article cases">
                  <h4 className="article-title">적용 사례</h4>
                  <div className="article-content">
                    <div className="list">
                      {cases.map((caseItem, index) => (
                        <div key={index} className="item">
                          <img src={caseItem.image} alt="" className="img" />
                          {caseItem.items ? (
                            <ul>
                              {caseItem.items.map((item, itemIndex) => (
                                <li key={itemIndex}>{item}</li>
                              ))}
                            </ul>
                          ) : null}
                        </div>
                      ))}
                    </div>
                  </div>
                </article>
              </LoadInView>
            )}
          </div>
        </CommonContainer>
      </div>
    </LoadInView>
  );
};

export default AssetSection;
